import React from "react";
import Image from "../../../elements/Image";
import Button from "../../../forms/Button";
import { useBanner } from "../../../../providers/BannerProviders";
import BannerImage01 from "../../../../assets/images/banner-image-01.jpg";
import BannerImage02 from "../../../../assets/images/banner-image-02.jpg";

const HomeBanner = () => {
  const { data } = useBanner();
  const homeBanner = data?.data?.find((item) => item?.slug === "turn-photos-into-personalized-coloring-books-1747829520846");
  // const words = homeBanner?.title?.trim()?.split(/\s+/) || [];
  const features = homeBanner?.features || [];
  return (
    <>
      <section className="relative py-20 flex items-center overflow-hidden bg-md-pink-light-2">
        <div className="relative w-full px-4 sm:px-0 sm:max-w-xl md:max-w-2xl lg:max-w-4xl xl:max-w-6xl 2xl:max-w-7xl 3xl:max-w-8xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-8 xl:gap-16 items-center text-center lg:text-left">
            <h1 className="text-5xl xl:text-7xl 3xl:text-8xl font-semibold tracking-tight banner-title text-md-dark" dangerouslySetInnerHTML={{ __html: homeBanner?.title || "" }} />
            <div className="relative flex row-span-3">
              <div className="grid grid-cols-2 gap-4 xl:gap-8 bg-md-peach-light rounded-3xl py-12 xl:py-20 px-6 xl:px-10 w-full shadow-xl shadow-md-pink/10">
                <div className="w-full aspect-[3/4] flex flex-shrink-0 overflow-hidden shadow-xl">
                  <Image src={homeBanner?.image[0]?.url || BannerImage01} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} />
                </div>
                <div className="w-full aspect-[3/4] flex flex-shrink-0 overflow-hidden shadow-xl">
                  <Image src={homeBanner?.image[1]?.url || BannerImage02} alt={""} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} />
                </div>
              </div>
            </div>
            <div
              className="text-xl xl:text-2xl 3xl:text-3xl font-light tracking-wide text-neutral-500 max-w-2xl"
              dangerouslySetInnerHTML={{
                __html: homeBanner?.description || "",
              }}
            />
            <div className="relative flex justify-center lg:justify-start">
              <Button buttonLabel={"Get Started Now"} buttonClasses={"!h-12 xl:!h-16 !px-8 xl:!px-12 shadow-lg shadow-md-pink/50 hover:shadow-md-pink xl:!pb-1"} buttonLabelClasses={"!text-lg xl:!text-2xl"} />
            </div>

          </div>
        </div>
      </section>
    </>
  );
};

export default HomeBanner;
